import React, { useState, useEffect } from 'react'
import { Modal, Form, Button, message } from 'antd'
import styles from './model.less'
import { print } from "@/utils/printUtils"
import { get as SafeGet, isArray, isString } from 'lodash'
import html2pdf from '@/utils/htmluploadpdf'
import createPdfDownload from '@/utils/html2pdf'

const PrintModal = ({
  taskDetail = {},
  info = {},
  visible,
  onCancel,
  ...other
}) => {
  const [infos, setInfos] = useState({})
  const [estimate, setEstimate] = useState([])
  const [advice, setAdvice] = useState([])
  const [train, setTrain] = useState([])
  useEffect(() => {
    if (info) {
      const { medicalEvaluate, psychologyConsult, psychologyTrain } = info
      const estimate = stringToArray(medicalEvaluate)
      const advice = stringToArray(psychologyConsult)
      const train = stringToArray(psychologyTrain)
      setInfos({ ...info })
      setEstimate(estimate)
      setAdvice(advice)
      setTrain(train)
    }
  }, [info])

  function stringToArray(str) {
    if (typeof str === 'string') {
      return str.split(',').map(item => {
        const parts = item.split('#')
        return [parts[0], parts[1] ? `(${parts[1]})` : '']
      })
    }
    return []
  }

  const handlePrint = () => {
    const printContent = document.getElementById("printEvaluationNew").parentNode
    setTimeout(() => {
      print(printContent)
    }, 1500)
  }

  const handleUploadPdf = () => {
    message.info('正在生成上传PDF文件')
    const printContent = document.getElementById("printEvaluationNew").parentNode
    if (printContent) {
      html2pdf(printContent, infos.id, 'new_bps_report', '/apis/custom_serve_report/period_evaluate_report/upload/')
    }
  }

  const handleCreateAndDownloadPdf = () => {
    message.success('正在下载')
    const printContent = document.getElementById('printEvaluationNew').parentNode
    if (printContent) {
      createPdfDownload(printContent)
    }
  }

  const modalProps = {
    visible: visible,
    width: 800,
    // okText: '打印',
    // footer: [
    //   <Button onClick={onCancel}>
    //     取消
    //   </Button>,
    //   <Button type="primary" onClick={handlePrint}>
    //     打印
    //   </Button>,
    //   <Button style={{ background: '#07c160', color: '#fff' }} onClick={handleUploadPdf}>
    //     分享2
    //   </Button>,
    // ],
    footer: null,
    ...other
  }

  const renderChoose = (arr) => {
    if (isArray(arr)) {
      return <div>
        {arr.map(it => {
          return <div style={{ marginRight: 10 }}>{it}</div>
        })}
      </div>
    }
    if (isString(arr)) {
      const newArr = arr.split(',')
      return <div>
        {newArr.map(it => {
          return <div style={{ marginRight: 10 }}>{it}</div>
        })}
      </div>
    }
  }
  const renderGradeRange = (score) => {
    if (score >= 0 && score <= 2) {
      return <span>0~2分 无</span>
    } else if (score >= 3 && score <= 6) {
      return <span>3~6分 轻度</span>
    } else if (score >= 7 && score <= 9) {
      return <span>7~9分 中度</span>
    } else {
      return <span>10分以上 重度</span>
    }
  }

  return (
    <Modal {...modalProps} closable={false}
      title={<div style={{ height: 32 }}>
        <span style={{ float: 'left' }}>预览打印</span>
        <span style={{ float: 'right' }}>
          <Button style={{ marginRight: 5 }} type='primary' onClick={handleCreateAndDownloadPdf}>下载</Button>
          <Button style={{ marginRight: 5 }} type='primary' onClick={handlePrint}>打印</Button>
          <Button style={{ background: '#07c160', color: '#fff', marginRight: 5 }} onClick={handleUploadPdf}>分享</Button>
          <Button onClick={onCancel}>取消</Button>
        </span>
      </div>}>
      <div id='printEvaluationNew'>
        <table className={styles.printEvaluationNew} border={0} cellPadding={0} cellSpacing={0} style={{ width: '562pt', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
          <tbody>
            <tr height={49} style={{ height: '49.00pt', msoHeightSource: 'userset', msoHeightAlt: 980 }}>
              <td className="xl67" colSpan={22} style={{ borderRight: '1.0pt solid windowtext', borderBottom: '.5pt solid #A6A6A6' }}>安肯心理BPS首咨评估报告</td>
            </tr>
            <tr height={25} style={{ height: '25.00pt', msoHeightSource: 'userset', msoHeightAlt: 500 }}>
              <td className="xl69" colSpan={6} style={{ borderRight: '.5pt solid #A6A6A6', borderBottom: '.5pt solid #A6A6A6' }}>来访姓名：{infos.customerName}</td>
              <td className="xl70" colSpan={6} style={{ borderRight: '.5pt solid #A6A6A6', borderBottom: '.5pt solid #A6A6A6' }}>心理顾问：{infos.consultantDoctorName}</td>
              <td className="xl70" colSpan={5} style={{ borderRight: '.5pt solid #A6A6A6', borderBottom: '.5pt solid #A6A6A6' }}>心理师：{infos.executorDoctorName}</td>
              <td className="xl120" colSpan={5} style={{ borderRight: '1.0pt solid windowtext', borderBottom: '.5pt solid #A6A6A6' }}>日期：{infos.serveDate}</td>
            </tr>
            <tr height={26} style={{ height: '26.00pt', msoHeightSource: 'userset', msoHeightAlt: 520 }}>
              <td className="xl71" colSpan={22} style={{ borderRight: '1.0pt solid windowtext', borderBottom: '.5pt solid #A6A6A6' }}>首次咨询(评估)总结</td>
            </tr>
            <tr height={26} style={{ height: '26.00pt', msoHeightSource: 'userset', msoHeightAlt: 520 }}>
              <td className="xl73" colSpan={4} style={{ borderRight: '.5pt solid #A6A6A6', borderBottom: '.5pt solid #A6A6A6' }}>问题类型</td>
              <td className="xl14" colSpan={18} style={{ borderRight: '1pt solid #000', borderBottom: '.5pt solid #A6A6A6' }}>{infos.questionType || taskDetail.questionTypeTwo}</td>
            </tr>
            <tr height={26} style={{ height: '26.00pt', msoHeightSource: 'userset', msoHeightAlt: 520 }}>
              <td className="xl75" colSpan={4} rowSpan={5} style={{ borderRight: '.5pt solid #BFBFBF', borderBottom: '.5pt solid #BFBFBF' }}>BPS评估总结</td>
              <td className="xl98" colSpan={6} style={{ borderRight: '.5pt solid #BFBFBF', borderBottom: '.5pt solid #BFBFBF' }}>生物症状表现</td>
              <td className="xl98" colSpan={6} style={{ borderRight: '.5pt solid #BFBFBF', borderBottom: '.5pt solid #BFBFBF' }}>社会诱发因素</td>
              <td className="xl98" colSpan={6} style={{ borderRight: '1.0pt solid windowtext', borderBottom: '.5pt solid #BFBFBF' }}>心理易感因素</td>
            </tr>
            <tr height={32} style={{ height: '32.00pt', msoHeightSource: 'userset', msoHeightAlt: 640 }}>
              <td className="xl99" colSpan={6} rowSpan={3} style={{ borderRight: '.5pt solid #BFBFBF', borderBottom: '.5pt solid #BFBFBF' }}>{renderChoose(infos.biologicalConceptualization)}</td>
              <td className="xl99" colSpan={6} rowSpan={3} style={{ borderRight: '.5pt solid #BFBFBF', borderBottom: '.5pt solid #BFBFBF' }}>{renderChoose(infos.socialConceptualization)}</td>
              <td className="xl99" colSpan={6} rowSpan={3} style={{ borderRight: '1.0pt solid windowtext', borderBottom: '.5pt solid #BFBFBF' }}>{renderChoose(infos.psychologicalConceptualization)}</td>
            </tr>
            <tr height={32} style={{ height: '32.00pt', msoHeightSource: 'userset', msoHeightAlt: 640 }}></tr>
            <tr height={32} style={{ height: '32.00pt', msoHeightSource: 'userset', msoHeightAlt: 640 }}></tr>
            <tr height={27} style={{ height: '27.00pt', msoHeightSource: 'userset', msoHeightAlt: 540 }}>
              <td className="xl80" colSpan={6} style={{ borderRight: '.5pt solid #BFBFBF', borderBottom: '.5pt solid #BFBFBF' }}>总分：{infos.evaluateGrade}分<span>&nbsp; </span>程度：{infos.evaluateLevel}</td>
              <td className="xl116" colSpan={12} style={{ borderRight: '1.0pt solid windowtext', borderBottom: '.5pt solid #BFBFBF' }}>注释：0~2 为无，3~6 为轻度，7~9为中度，10分以上为重度</td>
            </tr>
            <tr height={44} style={{ height: '44.00pt', msoHeightSource: 'userset', msoHeightAlt: 880 }}>
              <td className="xl79" colSpan={4} style={{ borderRight: '.5pt solid #BFBFBF', borderBottom: '.5pt solid #BFBFBF' }}>心理师总结</td>
              <td className="xl101" colSpan={6} style={{ borderRight: '.5pt solid #BFBFBF', borderBottom: '.5pt solid #BFBFBF' }}>{infos.clinicalConceptionSummarize}</td>
              <td className="xl101" colSpan={6} style={{ borderRight: '.5pt solid #BFBFBF', borderBottom: '.5pt solid #BFBFBF' }}>{infos.marriageSocietyConceptionSummarize}</td>
              <td className="xl101" colSpan={6} style={{ borderRight: '1.0pt solid windowtext', borderBottom: '.5pt solid #BFBFBF' }}>{infos.personalityFamilyConceptionSummarize}</td>
            </tr>
            <tr height={44} style={{ height: '55.00pt', msoHeightSource: 'userset', msoHeightAlt: 1100 }}>
              <td className="xl83" colSpan={4} style={{ borderRight: '.5pt solid #BFBFBF', borderBottom: '.5pt solid #BFBFBF' }}>SCL90量表分值体现</td>
              <td className="xl102" colSpan={18} style={{ borderRight: '1.0pt solid windowtext', borderBottom: '.5pt solid #BFBFBF' }}>{infos.scl90Desc}</td>
            </tr>
            <tr height={33} style={{ height: '33.00pt', msoHeightSource: 'userset', msoHeightAlt: 660 }}>
              <td className="xl81" colSpan={22} style={{ borderRight: '1.0pt solid windowtext', borderBottom: '.5pt solid #BFBFBF' }}>第一阶段心理服务目标</td>
            </tr>
            <tr height={55} style={{ height: '55.00pt', msoHeightSource: 'userset', msoHeightAlt: 1100 }}>
              <td className="xl83" colSpan={4} style={{ borderRight: '.5pt solid #BFBFBF', borderBottom: '.5pt solid #BFBFBF' }}>咨询目标</td>
              <td className="xl102" colSpan={18} style={{ borderRight: '1.0pt solid windowtext', borderBottom: '.5pt solid #BFBFBF' }}>{infos.firstPeriodConsultTarget}</td>
            </tr>
            <tr height={33} style={{ height: '33.00pt', msoHeightSource: 'userset', msoHeightAlt: 660 }}>
              <td className="xl81" colSpan={22} style={{ borderRight: '1.0pt solid windowtext', borderBottom: '.5pt solid #BFBFBF' }}>第一阶段(3个月内)综合心理服务方案</td>
            </tr>
            <tr height={27} style={{ height: '27.00pt', msoHeightSource: 'userset', msoHeightAlt: 540 }}>
              <td className="xl83" colSpan={4} style={{ borderRight: '.5pt solid #BFBFBF', borderBottom: '.5pt solid #BFBFBF' }}>建议方案次数</td>
              <td className="xl114" colSpan={18} style={{ borderRight: '1pt solid #000', borderBottom: '.5pt solid #BFBFBF' }}>{renderGradeRange(infos.evaluateGrade)}&nbsp;&nbsp;{infos.adviceTimes}</td>
            </tr>
            <tr height={27} style={{ height: '27.00pt', msoHeightSource: 'userset', msoHeightAlt: 540 }}>
              <td className="xl86" colSpan={4} rowSpan={7} style={{ borderRight: '.5pt solid #BFBFBF', borderBottom: '.5pt solid #BFBFBF' }}>方案项目</td>
              {/* <td className="xl104" colSpan={3} rowSpan={2} style={{ borderRight: '.5pt solid #BFBFBF', borderBottom: '.5pt solid #BFBFBF' }}>医学评估</td> */}
              <td className="xl107" colSpan={12} style={{ borderRight: '.5pt solid #BFBFBF', borderBottom: '.5pt solid #BFBFBF' }}>{estimate[0] && `${SafeGet(estimate, '0.0', '')}  ${SafeGet(estimate, '0.1', '')} `}</td>
              <td className="xl121" colSpan={6} rowSpan={7} style={{ borderRight: '1.0pt solid windowtext', borderBottom: '.5pt solid #BFBFBF' }}>
                备注：{infos.consultCostDetail}
              </td>
            </tr>
            <tr height={27} style={{ height: '27.00pt', msoHeightSource: 'userset', msoHeightAlt: 540 }}>
              <td className="xl107" colSpan={12} style={{ borderRight: '.5pt solid #BFBFBF', borderBottom: '.5pt solid #BFBFBF' }}>{estimate[1] && `${SafeGet(estimate, '1.0', '')}  ${SafeGet(estimate, '1.1', '')} `}</td>
            </tr>
            <tr height={27} style={{ height: '27.00pt', msoHeightSource: 'userset', msoHeightAlt: 540 }}>
              {/* <td className="xl104" colSpan={3} rowSpan={3} style={{ borderRight: '.5pt solid #BFBFBF', borderBottom: '.5pt solid #BFBFBF' }}>心理咨询</td> */}
              <td className="xl107" colSpan={12} style={{ borderRight: '.5pt solid #BFBFBF', borderBottom: '.5pt solid #BFBFBF' }}>{advice[0] && `${SafeGet(advice, '0.0', '')}  ${SafeGet(advice, '0.1', '')} `}</td>
            </tr>
            <tr height={27} style={{ height: '27.00pt', msoHeightSource: 'userset', msoHeightAlt: 540 }}>
              <td className="xl107" colSpan={12} style={{ borderRight: '.5pt solid #BFBFBF', borderBottom: '.5pt solid #BFBFBF' }}>{advice[1] && `${SafeGet(advice, '1.0', '')}  ${SafeGet(advice, '1.1', '')} `}</td>
            </tr>
            <tr height={27} style={{ height: '27.00pt', msoHeightSource: 'userset', msoHeightAlt: 540 }}>
              <td className="xl107" colSpan={12} style={{ borderRight: '.5pt solid #BFBFBF', borderBottom: '.5pt solid #BFBFBF' }}>{advice[2] && `${SafeGet(advice, '2.0', '')}  ${SafeGet(advice, '2.1', '')} `}</td>
            </tr>
            <tr height={27} style={{ height: '27.00pt', msoHeightSource: 'userset', msoHeightAlt: 540 }}>
              {/* <td className="xl104" colSpan={3} rowSpan={2} style={{ borderRight: '.5pt solid #BFBFBF', borderBottom: '.5pt solid #BFBFBF' }}>心理训练</td> */}
              <td className="xl107" colSpan={12} style={{ borderRight: '.5pt solid #BFBFBF', borderBottom: '.5pt solid #BFBFBF' }}>{train[0] && `${SafeGet(train, '0.0', '')}  ${SafeGet(train, '0.1', '')} `}</td>
              {/* <td className="xl121" colSpan={7} rowSpan={2} style={{ borderRight: '1.0pt solid windowtext', borderBottom: '.5pt solid #BFBFBF' }}>
                私人个性化定制方案：{infos.personalCustomizedSolution}
              </td> */}
            </tr>
            <tr height={27} style={{ height: '27.00pt', msoHeightSource: 'userset', msoHeightAlt: 540 }}>
              <td className="xl107" colSpan={12} style={{ borderRight: '.5pt solid #BFBFBF', borderBottom: '.5pt solid #BFBFBF' }}>{train[1] && `${SafeGet(train, '1.0', '')}  ${SafeGet(train, '1.1', '')} `}</td>
            </tr>
            {/* <tr height={27} style={{ height: '27.00pt', msoHeightSource: 'userset', msoHeightAlt: 540 }}>
              <td className="xl107" colSpan={9} style={{ borderRight: '.5pt solid #BFBFBF', borderBottom: '.5pt solid #BFBFBF' }}>{train[2] && `${SafeGet(train, '2.0', '')}  ${SafeGet(train, '2.1', '')} `}</td>
            </tr> */}
            <tr height={67} style={{ height: '67.00pt', msoHeightSource: 'userset', msoHeightAlt: 1340 }}>
              <td className="xl95" colSpan={4} style={{ borderRight: '.5pt solid #BFBFBF', borderBottom: '1.0pt solid windowtext' }}>备注说明：</td>
              <td className="xl114" colSpan={18} style={{ borderRight: '1.0pt solid windowtext', borderBottom: '1.0pt solid windowtext' }}>{infos.remarkComment}</td>
            </tr>
            {
              infos.imageArray && infos.imageArray.map(it => {
                return <img style={{ width: 750 }} src={it} />
              })
            }
          </tbody></table>
      </div>
    </Modal>
  )
}

export default Form.create()(PrintModal)
